<div class="modal-header border-bottom-0">
  <h5 class="modal-title">{{'common.modals.helpModal.heading' | translate}}</h5>
  <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [innerHTML]="'common.modals.helpModal.content' | translate" class="modal-body pb-5"></div>
